// // src/components/dermatology/DermImageViewerTab.tsx
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../../css/DermImageViewerTab.css";
// import ImageViewer from "../charting/ImageViewer";
// import DermReportSection from "./DermReportSection";
// import api from "../../api/axiosConfig";
// import { ReportRecommendations } from "../../pages/DermatologyScreen";

// interface DermTabProps {
//   telePrognosis: string;
//   setTelePrognosis: (value: string) => void;
//   medicalAdvice: string;
//   setMedicalAdvice: (value: string) => void;
//   recommendations: ReportRecommendations;
//   setRecommendations: (recommendations: ReportRecommendations) => void;
// }

// interface DermImageViewerTabProps {
//   emrId: string;
//   patientAge: number;
//   doctorName: string;
//   userId: string;

//   // 🔥 ADD THIS
//   showADTab: boolean;

//   activeSubTab: "derma" | "ad";
// }


// type SubTab = "Oral Cavity" | "Hair" | "Nails" | "Skin" | "Atopic Dermatitis";

// type MainTab = "derma" | "ad";

// const SUB_TABS: SubTab[] = [
//   "Oral Cavity",
//   "Hair",
//   "Nails",
//   "Skin",
//   "Atopic Dermatitis",
// ];

// const ATOPIC_LABELS = [
//   "Erythema",
//   "White Patches",
//   "Darkening around the Eyelids",
//   "Infra Orbital Folds",
//   "Dry Lips",
//   "Anterior Neck-Folds",
//   "Dry Skin",
//   "Increased Lines Over Palms",
//   "Hand and Foot Eczema",
//   "Nipple Eczema",
// ];

// const SUBMIT_ENDPOINT: Record<SubTab, string> = {
//   "Oral Cavity": "/teledocs/dermatology/oral-cavity/report",
//   Hair: "/teledocs/dermatology/hair/report",
//   Nails: "/teledocs/dermatology/nails/report",
//   Skin: "/teledocs/dermatology/skin/report",
//   "Atopic Dermatitis": "/teledocs/dermatology/atopic-dermatitis/report",
// };

// /* ---------- UI TAB → S3 MODULE (EXACT BACKEND MATCH) ---------- */
// const VIEW_TO_MODULE: Record<SubTab, string> = {
//   "Oral Cavity": "physical-exam/oral",
//   Hair: "physical-exam/hair",
//   Nails: "physical-exam/nails",
//   Skin: "physical-exam/skin",
//   "Atopic Dermatitis": "ad-minor/atopic",
// };

// /* ---------- UI TAB → BACKEND KEY (SAFETY) ---------- */
// const UI_VIEW_TO_DATA_KEY: Record<SubTab, string> = {
//   "Oral Cavity": "Oral Cavity",
//   Hair: "Hair",
//   Nails: "Nails",
//   Skin: "Skin",
//   "Atopic Dermatitis": "Atopic Dermatitis",
// };

// const DermImageViewerTab: React.FC<DermImageViewerTabProps> = ({
//   emrId,
//   patientAge,
//   doctorName,
//   userId,
// }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const caseId = (location.state as any)?.caseId;

//   const [activeMainTab, setActiveMainTab] = useState<MainTab>("derma");
//   const [activeSubTab, setActiveSubTab] = useState<SubTab>("Oral Cavity");
//   const [dermImages, setDermImages] = useState<Record<string, string[]>>({});
//   const [atopicImages, setAtopicImages] = useState<string[]>([]);
//   const [signedImageMap, setSignedImageMap] = useState<
//     Record<string, string[]>
//   >({});
//   const [selectedImage, setSelectedImage] = useState<string>("");

//   const DERMA_TABS: SubTab[] = ["Oral Cavity", "Hair", "Nails", "Skin"];

//   const AD_TABS: SubTab[] = ["Atopic Dermatitis"];

//   const [completedTabs, setCompletedTabs] = useState<SubTab[]>([]);
//   const totalTabs = SUB_TABS.length;

//   const progressPercentage = Math.round(
//     (completedTabs.length / totalTabs) * 100,
//   );

//   const [reportData, setReportData] = useState<
//     Record<
//       SubTab,
//       {
//         telePrognosis: string;
//         medicalAdvice: string;
//         recommendations: {
//           none: boolean;
//           followAdvice: boolean;
//           consultDerm: boolean;
//         };
//       }
//     >
//   >(() => {
//     const initial = {
//       telePrognosis: "",
//       medicalAdvice: "",
//       recommendations: {
//         none: false,
//         followAdvice: false,
//         consultDerm: false,
//       },
//     };

//     return {
//       "Oral Cavity": { ...initial },
//       Hair: { ...initial },
//       Nails: { ...initial },
//       Skin: { ...initial },
//       "Atopic Dermatitis": { ...initial },
//     };
//   });
//   const currentReport = reportData[activeSubTab];

//   /* -------- FETCH IMAGE KEYS FROM PHYSICAL EXAM -------- */
//   useEffect(() => {
//     if (!emrId) return;
//     const fetchDermImages = async () => {
//       try {
//         const res = await api.dataCollectionApi.get(
//           `/api/forms/physical-exam/${emrId}`,
//         );

//         if (res.data?.success && res.data?.data) {
//           const data = res.data.data;

//           const normalizedImages: Record<string, string[]> = {
//             Hair: data.hair?.imageUrls || [],
//             Nails: data.nails?.imageUrls || [],
//             "Oral Cavity": data.oralCavity?.imageUrls || [],
//             Skin: data.skinExam?.imageUrls || [],
//           };

//           setDermImages(normalizedImages);
//         }
//       } catch (err) {
//         console.error("Failed to fetch dermatology images:", err);
//       }
//     };

//     fetchDermImages();
//   }, []);

//   /* -------- FETCH IMAGE KEYS FROM Atopic Dermatitis -------- */

//   useEffect(() => {
//     if (!emrId) return;
//     if (activeSubTab !== "Atopic Dermatitis") return;

//     const fetchAtopicImages = async () => {
//       try {
//         const res = await api.dataCollectionApi.get(
//           `/api/forms/atopic-dermatitis/${emrId}`,
//         );

//         if (res.data?.success && Array.isArray(res.data?.data?.features)) {
//           const allKeys: string[] = [];

//           res.data.data.features.forEach((feature: any) => {
//             if (Array.isArray(feature.imageUrls)) {
//               feature.imageUrls.forEach((url: string) => {
//                 // ✅ Only allow real S3 object keys
//                 if (
//                   url.startsWith("ad-minor/") ||
//                   url.startsWith("physical-exam/")
//                 ) {
//                   allKeys.push(url);
//                 }
//               });
//             }
//           });

//           setAtopicImages(allKeys);
//         }
//       } catch (err) {
//         console.error("Failed to fetch atopic dermatitis images:", err);
//       }
//     };

//     fetchAtopicImages();
//   }, [activeSubTab]);

//   /* ---------- FETCH PRESIGNED URLS (TELE DOCTOR LOGIC) ---------- */
//   useEffect(() => {
//     if (!dermImages || Object.keys(dermImages).length === 0) return;

//     const fetchSignedUrls = async () => {
//       const INTERNAL_TOKEN = "super-secret-password";
//       const map: Record<string, string[]> = {};

//       for (const [view, keys] of Object.entries(dermImages)) {
//         if (!Array.isArray(keys)) continue;

//         const uiKey = view as SubTab;
//         map[uiKey] = [];

//         for (const fullPath of keys) {
//           try {
//             let module = "";
//             let key = "";

//             // A) Full S3 path exists
//             if (typeof fullPath === "string" && fullPath.includes("/")) {
//               const parts = fullPath.split("/");
//               if (parts.length < 2) continue;

//               module = `${parts[0]}/${parts[1]}`;
//               key = parts.slice(2).join("/");
//             }
//             // B) Only filename exists
//             else {
//               module = VIEW_TO_MODULE[uiKey];
//               key = String(fullPath);
//             }

//             if (!module || !key) continue;

//             const res = await api.S3config.get("/view-url", {
//               params: { module, key },
//               headers: { "x-internal-token": INTERNAL_TOKEN },
//             });

//             if (res.data?.url) {
//               map[uiKey].push(res.data.url);
//             }
//           } catch (err) {
//             console.error("Presign failed:", err);
//           }
//         }
//       }

//       setSignedImageMap(map);
//     };

//     fetchSignedUrls();
//   }, [dermImages]);

//   /* ---------- FETCH PRESIGNED URLS FOR Atopic Dermatitis ---------- */

//   useEffect(() => {
//     if (activeSubTab !== "Atopic Dermatitis") return;
//     if (atopicImages.length === 0) return;

//     const fetchSignedUrls = async () => {
//       const INTERNAL_TOKEN = "super-secret-password";
//       const urls: string[] = [];

//       for (const fullPath of atopicImages) {
//         try {
//           const parts = fullPath.split("/");
//           if (parts.length < 3) continue;

//           const module = `${parts[0]}/${parts[1]}`; // ad-minor/atopic
//           const key = parts.slice(2).join("/");

//           const res = await api.S3config.get("/view-url", {
//             params: { module, key },
//             headers: { "x-internal-token": INTERNAL_TOKEN },
//           });

//           if (res.data?.url) {
//             urls.push(res.data.url);
//           }
//         } catch (err) {
//           console.error("Presign failed:", err);
//         }
//       }

//       setSignedImageMap((prev) => ({
//         ...prev,
//         "Atopic Dermatitis": urls,
//       }));
//     };

//     fetchSignedUrls();
//   }, [atopicImages, activeSubTab]);

//   /* ---------- RESET HANDLER ---------- */

//   const handleResetReport = () => {
//     setReportData((prev) => ({
//       ...prev,
//       [activeSubTab]: {
//         telePrognosis: "",
//         medicalAdvice: "",
//         recommendations: {
//           none: false,
//           followAdvice: false,
//           consultDerm: false,
//         },
//       },
//     }));
//   };

//   /* ---------- SUBMIT HANDLER (WITH VALIDATION + AUTO RESET) ---------- */

//   const handleSubmitReport = async () => {
//     const endpoint = SUBMIT_ENDPOINT[activeSubTab];
//     if (!endpoint) return;

//     // 1️⃣ Tele-Prognosis validation
//     if (!currentReport.telePrognosis.trim()) {
//       alert("Please enter Tele-Prognosis");
//       return;
//     }

//     // 2️⃣ Medical Advice validation
//     if (!currentReport.medicalAdvice.trim()) {
//       alert("Please enter Medical Advice");
//       return;
//     }

//     // 3️⃣ At least one recommendation selected
//     const selectedCount = Object.values(currentReport.recommendations).filter(
//       Boolean,
//     ).length;

//     if (selectedCount === 0) {
//       alert("Please select at least one Recommendation");
//       return;
//     }

//     try {
//       const payload = {
//         emrId,
//         chartType: "primary",
//         age: String(patientAge), // backend expects string
//         doctorName,
//         reportWriting: {
//           telePrognosis: currentReport.telePrognosis,
//           medicalAdvice: currentReport.medicalAdvice,
//           recommendations: {
//             none: currentReport.recommendations.none,
//             followMedicalAdvice: currentReport.recommendations.followAdvice,
//             consultPediatricDermatologist:
//               currentReport.recommendations.consultDerm,
//           },
//         },
//         status: "SUBMITTED",
//         createdBy: userId,
//       };

//       const res = await api.dataCollectionApi.post(endpoint, payload);

//       if (res.data?.success) {
//         // Mark this tab as completed (avoid duplicates)
//         setCompletedTabs((prev) =>
//           prev.includes(activeSubTab) ? prev : [...prev, activeSubTab],
//         );

//         handleResetReport();

//         // If NOT last tab → move to next tab
//         if (activeSubTab !== "Atopic Dermatitis") {
//           const currentIndex = SUB_TABS.indexOf(activeSubTab);
//           const nextTab = SUB_TABS[currentIndex + 1];

//           if (nextTab) {
//             setActiveSubTab(nextTab);
//           }
//         } else {
//           // Last tab → complete workflow
//           try {
//             await api.CenterworkflowApi.post(
//               `/postworkflow/cases/${caseId}/tasks/DERMATOLOGY/complete`,
//             );
//           } catch (err) {
//             console.error("Failed to complete Dermatology task", err);
//           }

//           navigate("/queue/dermatology");
//         }
//       }
//     } catch (err) {
//       console.error("Submit failed:", err);
//       alert("Failed to submit report");
//     }
//   };

//   /* ---------- UPDATE IMAGE ON TAB CHANGE ---------- */

//   useEffect(() => {
//     const images = signedImageMap[activeSubTab] || [];
//     setSelectedImage(images.length > 0 ? images[0] : "");
//   }, [activeSubTab, signedImageMap]);

//   return (
//     <div className="derm-image-viewer-container">
//       {/* Sub Tabs */}

//       {/* <div className="sub-tabs-container">
//         {SUB_TABS.map((tab) => (
//           <button
//             key={tab}
//             className={`sub-tab ${activeSubTab === tab ? "active" : ""}`}
//             onClick={() => setActiveSubTab(tab)}
//           >
//             {tab}
//             {completedTabs.includes(tab) && " ✓"}
//           </button>
//         ))}
//       </div> */}

//       {/* MAIN TABS */}
//       <div className="main-tabs-container">
        
//       </div>

//       {/* SUB TABS */}
//       <div className="sub-tabs-container">
//         {(activeMainTab === "derma" ? DERMA_TABS : AD_TABS).map((tab) => (
//           <button
//             key={tab}
//             className={`sub-tab ${activeSubTab === tab ? "active" : ""}`}
//             onClick={() => setActiveSubTab(tab)}
//           >
//             {tab}
//             {completedTabs.includes(tab) && " ✓"}
//           </button>
//         ))}
//       </div>

//       {/* Image Gallery */}
//       <div className="image-gallery-area">
//         <div className="thumbnails-bar">
//           {(signedImageMap[activeSubTab] || []).map((url, index) => (
//             <div
//               key={index}
//               className={`thumbnail ${selectedImage === url ? "active" : ""}`}
//               onClick={() => setSelectedImage(url)}
//             >
//               {activeSubTab === "Atopic Dermatitis" && (
//                 <div className="thumbnail-title">
//                   {ATOPIC_LABELS[index] || `File ${index + 1}`}
//                 </div>
//               )}

//               <img src={url} alt={`thumb-${index}`} />
//             </div>
//           ))}
//         </div>

//         <div className="main-image-view">
//           <ImageViewer
//             imageSrc={
//               selectedImage ||
//               "https://placehold.co/800x600/f1f1f1/ccc?text=No+Images"
//             }
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DermImageViewerTab;







// src/components/dermatology/DermImageViewerTab.tsx

  // import React, { useEffect, useState } from "react";
  // import { useLocation, useNavigate } from "react-router-dom";
  // import "../../css/DermImageViewerTab.css";
  // import ImageViewer from "../charting/ImageViewer";
  // import api from "../../api/axiosConfig";

  // interface DermImageViewerTabProps {
  //   emrId: string;
  //   patientAge: number;
  //   doctorName: string;
  //   userId: string;

  //   showADTab: boolean;

  //   // 🔥 PARENT TAB FROM SCREEN
  //   activeSubTab: "derma" | "ad";
  // }

  // type ImageTab =
  //   | "Oral Cavity"
  //   | "Hair"
  //   | "Nails"
  //   | "Skin"
  //   | "Atopic Dermatitis";

  // const DERMA_TABS: ImageTab[] = [
  //   "Oral Cavity",
  //   "Hair",
  //   "Nails",
  //   "Skin",
  // ];

  // const AD_TABS: ImageTab[] = ["Atopic Dermatitis"];

  // const VIEW_TO_MODULE: Record<ImageTab, string> = {
  //   "Oral Cavity": "physical-exam/oral",
  //   Hair: "physical-exam/hair",
  //   Nails: "physical-exam/nails",
  //   Skin: "physical-exam/skin",
  //   "Atopic Dermatitis": "ad-minor/atopic",
  // };

  // const ATOPIC_LABELS = [
  //   "Erythema",
  //   "White Patches",
  //   "Darkening around the Eyelids",
  //   "Infra Orbital Folds",
  //   "Dry Lips",
  //   "Anterior Neck-Folds",
  //   "Dry Skin",
  //   "Increased Lines Over Palms",
  //   "Hand and Foot Eczema",
  //   "Nipple Eczema",
  // ];

  // const DermImageViewerTab: React.FC<DermImageViewerTabProps> = ({
  //   emrId,
  //   activeSubTab,
  // }) => {
  //   const location = useLocation();
  //   const navigate = useNavigate();

  //   const [activeImageTab, setActiveImageTab] =
  //     useState<ImageTab>("Oral Cavity");

  //   const [dermImages, setDermImages] = useState<
  //     Record<string, string[]>
  //   >({});

  //   const [atopicImages, setAtopicImages] = useState<string[]>([]);

  //   const [signedImageMap, setSignedImageMap] = useState<
  //     Record<string, string[]>
  //   >({});

  //   const [selectedImage, setSelectedImage] =
  //     useState<string>("");

  //   /* =========================================
  //     AUTO CHANGE IMAGE TAB WHEN MAIN TAB CHANGES
  //   ========================================= */

  //   useEffect(() => {
  //     if (activeSubTab === "derma") {
  //       setActiveImageTab("Oral Cavity");
  //     } else {
  //       setActiveImageTab("Atopic Dermatitis");
  //     }
  //   }, [activeSubTab]);

  //   /* =========================================
  //     FETCH PHYSICAL EXAM IMAGES
  //   ========================================= */

  //   // useEffect(() => {
  //   //   if (!emrId) return;

  //   //   const fetchDermImages = async () => {
  //   //     try {
  //   //       const res = await api.dataCollectionApi.get(
  //   //         `/api/forms/physical-exam/${emrId}`,
  //   //       );

  //   //       if (res.data?.success && res.data?.data) {
  //   //         const data = res.data.data;

  //   //         const normalizedImages: Record<string, string[]> = {
  //   //           Hair: data.hair?.imageUrls || [],
  //   //           Nails: data.nails?.imageUrls || [],
  //   //           "Oral Cavity":
  //   //             data.oralCavity?.imageUrls || [],
  //   //           Skin: data.skinExam?.imageUrls || [],
  //   //         };

  //   //         setDermImages(normalizedImages);
  //   //       }
  //   //     } catch (err) {
  //   //       console.error(
  //   //         "Failed to fetch dermatology images:",
  //   //         err,
  //   //       );
  //   //     }
  //   //   };

  //   //   fetchDermImages();
  //   // }, [emrId]);



  //   /* =========================================
  //     FETCH PHYSICAL EXAM IMAGES
  //   ========================================= */

  //   useEffect(() => {
  //     if (!emrId) return;

  //     const fetchDermImages = async () => {
  //       try {
  //         const res = await api.dataCollectionApi.get(
  //           `/api/forms/physical-exam/${emrId}`
  //         );

  //         if (res.data?.success && res.data?.data) {
  //           const data = res.data.data;

  //           // 🔥 Safely extract Skin Images from BOTH the root and the new nested regions
  //           const skinImages: string[] = [];
            
  //           // 1. Root level (legacy/flat structure)
  //           if (Array.isArray(data.skinExam?.imageUrls)) {
  //             skinImages.push(...data.skinExam.imageUrls);
  //           }
            
  //           // 2. Nested regions (new Zod schema structure)
  //           const regions = ["face", "upperLimb", "lowerLimb", "trunk"];
  //           regions.forEach((region) => {
  //             if (Array.isArray(data.skinExam?.[region]?.imageUrls)) {
  //               skinImages.push(...data.skinExam[region].imageUrls);
  //             }
  //           });

  //           // Normalize the images object
  //           const normalizedImages: Record<string, string[]> = {
  //             Hair: data.hair?.imageUrls || [],
  //             Nails: data.nails?.imageUrls || [],
  //             "Oral Cavity": data.oralCavity?.imageUrls || [],
  //             Skin: skinImages, // Use our combined array here
  //           };

  //           setDermImages(normalizedImages);
  //         }
  //       } catch (err) {
  //         console.error("Failed to fetch dermatology images:", err);
  //       }
  //     };

  //     fetchDermImages();
  //   }, [emrId]);

  //   /* =========================================
  //     FETCH AD IMAGES
  //   ========================================= */

  //   useEffect(() => {
  //     if (activeImageTab !== "Atopic Dermatitis")
  //       return;

  //     const fetchAtopicImages = async () => {
  //       try {
  //         const res = await api.dataCollectionApi.get(
  //           `/api/forms/atopic-dermatitis/${emrId}`,
  //         );

  //         if (
  //           res.data?.success &&
  //           Array.isArray(res.data?.data?.features)
  //         ) {
  //           const allKeys: string[] = [];

  //           res.data.data.features.forEach(
  //             (feature: any) => {
  //               if (Array.isArray(feature.imageUrls)) {
  //                 feature.imageUrls.forEach(
  //                   (url: string) => {
  //                     allKeys.push(url);
  //                   },
  //                 );
  //               }
  //             },
  //           );

  //           setAtopicImages(allKeys);
  //         }
  //       } catch (err) {
  //         console.error(
  //           "Failed to fetch atopic images:",
  //           err,
  //         );
  //       }
  //     };

  //     fetchAtopicImages();
  //   }, [activeImageTab, emrId]);

  //   // /* =========================================
  //   //    FETCH SIGNED URLS - DERMA
  //   // ========================================= */

  //   // useEffect(() => {
  //   //   if (!Object.keys(dermImages).length) return;

  //   //   const fetchSignedUrls = async () => {
  //   //     const INTERNAL_TOKEN = "super-secret-password";

  //   //     const map: Record<string, string[]> = {};

  //   //     for (const [view, keys] of Object.entries(
  //   //       dermImages,
  //   //     )) {
  //   //       map[view] = [];

  //   //       for (const fullPath of keys) {
  //   //         try {
  //   //           let module = "";
  //   //           let key = "";

  //   //           if (fullPath.includes("/")) {
  //   //             const parts = fullPath.split("/");

  //   //             module = `${parts[0]}/${parts[1]}`;
  //   //             key = parts.slice(2).join("/");
  //   //           } else {
  //   //             module =
  //   //               VIEW_TO_MODULE[view as ImageTab];
  //   //             key = fullPath;
  //   //           }

  //   //           const res = await api.S3config.get(
  //   //             "/view-url",
  //   //             {
  //   //               params: { module, key },
  //   //               headers: {
  //   //                 "x-internal-token":
  //   //                   INTERNAL_TOKEN,
  //   //               },
  //   //             },
  //   //           );

  //   //           if (res.data?.url) {
  //   //             map[view].push(res.data.url);
  //   //           }
  //   //         } catch (err) {
  //   //           console.error("Presign failed:", err);
  //   //         }
  //   //       }
  //   //     }

  //   //     setSignedImageMap(map);
  //   //   };

  //   //   fetchSignedUrls();
  //   // }, [dermImages]);

  //   // /* =========================================
  //   //    FETCH SIGNED URLS - AD
  //   // ========================================= */

  //   // useEffect(() => {
  //   //   if (!atopicImages.length) return;

  //   //   const fetchSignedUrls = async () => {
  //   //     const INTERNAL_TOKEN = "super-secret-password";

  //   //     const urls: string[] = [];

  //   //     for (const fullPath of atopicImages) {
  //   //       try {
  //   //         const parts = fullPath.split("/");

  //   //         const module = `${parts[0]}/${parts[1]}`;
  //   //         const key = parts.slice(2).join("/");

  //   //         const res = await api.S3config.get(
  //   //           "/view-url",
  //   //           {
  //   //             params: { module, key },
  //   //             headers: {
  //   //               "x-internal-token":
  //   //                 INTERNAL_TOKEN,
  //   //             },
  //   //           },
  //   //         );

  //   //         if (res.data?.url) {
  //   //           urls.push(res.data.url);
  //   //         }
  //   //       } catch (err) {
  //   //         console.error("Presign failed:", err);
  //   //       }
  //   //     }

  //   //     setSignedImageMap((prev) => ({
  //   //       ...prev,
  //   //       "Atopic Dermatitis": urls,
  //   //     }));
  //   //   };

  //   //   fetchSignedUrls();
  //   // }, [atopicImages]);


  // /* =========================================
  //     FETCH SIGNED URLS - DERMA
  //   ========================================= */
  // /* =========================================
  //     FETCH SIGNED URLS - DERMA
  //   ========================================= */

  //   useEffect(() => {
  //     if (!Object.keys(dermImages).length) return;

  //     const fetchSignedUrls = async () => {
  //       const INTERNAL_TOKEN = "super-secret-password";
  //       const map: Record<string, string[]> = {};

  //       for (const [view, keys] of Object.entries(dermImages)) {
  //         map[view] = [];

  //         for (const fullPath of keys) {
  //           if (!fullPath) continue;

  //           try {
  //             let cleanPath = fullPath;

  //             // 🔥 FIX: If the DB saved a full (but expired) AWS URL, extract just the pure file path
  //             if (fullPath.startsWith("http")) {
  //               const urlObj = new URL(fullPath);
  //               // This removes the domain and the leading slash to get e.g. "physical-exam/skin/trunk/..."
  //               cleanPath = urlObj.pathname.substring(1); 
  //             }

  //             let module = "";
  //             let key = cleanPath;

  //             if (cleanPath.includes("/")) {
  //               const parts = cleanPath.split("/");
  //               module = `${parts[0]}/${parts[1]}`; // e.g., "physical-exam/skin"
  //               key = parts.slice(2).join("/");     // e.g., "trunk/P-2026.../file.png"
  //             } else {
  //               // Dynamic module mapping for skin regions
  //               if (view === "Skin") {
  //                 if (cleanPath.includes("_face_")) {
  //                   module = "physical-exam/skin/face";
  //                 } else if (cleanPath.includes("_upper-limb_")) {
  //                   module = "physical-exam/skin/upper-limb";
  //                 } else if (cleanPath.includes("_lower-limb_")) {
  //                   module = "physical-exam/skin/lower-limb";
  //                 } else if (cleanPath.includes("_trunk_")) {
  //                   module = "physical-exam/skin/trunk";
  //                 } else {
  //                   module = "physical-exam/skin";
  //                 }
  //               } else {
  //                 module = VIEW_TO_MODULE[view as ImageTab];
  //               }
  //             }

  //             // Ask the backend for a FRESH presigned URL
  //             const res = await api.S3config.get("/view-url", {
  //               params: { module, key },
  //               headers: { "x-internal-token": INTERNAL_TOKEN },
  //             });

  //             if (res.data?.url) {
  //               const signedUrl = res.data.url.startsWith("http") 
  //                 ? res.data.url 
  //                 : `https://${res.data.url}`;
                
  //               map[view].push(signedUrl);
  //             }
  //           } catch (err) {
  //             console.error(`Presign failed for ${view}:`, err);
  //           }
  //         }
  //       }

  //       setSignedImageMap(map);
  //     };

  //     fetchSignedUrls();
  //   }, [dermImages]);
  //   /* =========================================
  //     FETCH SIGNED URLS - AD
  //   ========================================= */

  //   useEffect(() => {
  //     if (!atopicImages.length) return;

  //     const fetchSignedUrls = async () => {
  //       const INTERNAL_TOKEN = "super-secret-password";
  //       const urls: string[] = [];

  //       for (const fullPath of atopicImages) {
  //         if (!fullPath) continue;

  //         // 🔥 FIX 1: If it's already a full URL, skip signing
  //         if (fullPath.startsWith("http")) {
  //           urls.push(fullPath);
  //           continue;
  //         }

  //         try {
  //           const parts = fullPath.split("/");
  //           const module = `${parts[0]}/${parts[1]}`;
  //           const key = parts.slice(2).join("/");

  //           const res = await api.S3config.get("/view-url", {
  //             params: { module, key },
  //             headers: { "x-internal-token": INTERNAL_TOKEN },
  //           });

  //           if (res.data?.url) {
  //             const signedUrl = res.data.url.startsWith("http") 
  //                 ? res.data.url 
  //                 : `https://${res.data.url}`;
                  
  //             urls.push(signedUrl);
  //           }
  //         } catch (err) {
  //           console.error("Presign failed for AD:", err);
  //         }
  //       }

  //       setSignedImageMap((prev) => ({
  //         ...prev,
  //         "Atopic Dermatitis": urls,
  //       }));
  //     };

  //     fetchSignedUrls();
  //   }, [atopicImages]);

  //   /* =========================================
  //     AUTO SELECT IMAGE
  //   ========================================= */

  //   useEffect(() => {
  //     const images =
  //       signedImageMap[activeImageTab] || [];

  //     setSelectedImage(
  //       images.length > 0 ? images[0] : "",
  //     );
  //   }, [activeImageTab, signedImageMap]);

  //   return (
  //     <div className="derm-image-viewer-container">

  //       {/* SUB TABS */}

  //       <div className="sub-tabs-container">
  //         {(activeSubTab === "derma"
  //           ? DERMA_TABS
  //           : AD_TABS
  //         ).map((tab) => (
  //           <button
  //             key={tab}
  //             className={`sub-tab ${
  //               activeImageTab === tab
  //                 ? "active"
  //                 : ""
  //             }`}
  //             onClick={() =>
  //               setActiveImageTab(tab)
  //             }
  //           >
  //             {tab}
  //           </button>
  //         ))}
  //       </div>

  //       {/* IMAGE AREA */}

  //       <div className="image-gallery-area">

  //         {/* THUMBNAILS */}

  //         <div className="thumbnails-bar">
  //           {(
  //             signedImageMap[activeImageTab] || []
  //           ).map((url, index) => (
  //             <div
  //               key={index}
  //               className={`thumbnail ${
  //                 selectedImage === url
  //                   ? "active"
  //                   : ""
  //               }`}
  //               onClick={() =>
  //                 setSelectedImage(url)
  //               }
  //             >
  //               {activeImageTab ===
  //                 "Atopic Dermatitis" && (
  //                 <div className="thumbnail-title">
  //                   {ATOPIC_LABELS[index] ||
  //                     `File ${index + 1}`}
  //                 </div>
  //               )}

  //               <img
  //                 src={url}
  //                 alt={`thumb-${index}`}
  //               />
  //             </div>
  //           ))}
  //         </div>

  //         {/* MAIN IMAGE */}

  //         <div className="main-image-view">
  //           <ImageViewer
  //             imageSrc={
  //               selectedImage ||
  //               "https://placehold.co/800x600/f1f1f1/ccc?text=No+Images"
  //             }
  //           />
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // export default DermImageViewerTab;




  // src/components/dermatology/DermImageViewerTab.tsx

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/DermImageViewerTab.css";
import ImageViewer from "../charting/ImageViewer";
import api from "../../api/axiosConfig";

interface DermImageViewerTabProps {
  emrId: string;
  patientAge: number;
  doctorName: string;
  userId: string;
  showADTab: boolean;
  activeSubTab: "derma" | "ad";
}

type ImageTab =
  | "Oral Cavity"
  | "Hair"
  | "Nails"
  | "Skin"
  | "Atopic Dermatitis";

const DERMA_TABS: ImageTab[] = [
  "Oral Cavity",
  "Hair",
  "Nails",
  "Skin",
];

const AD_TABS: ImageTab[] = ["Atopic Dermatitis"];

const VIEW_TO_MODULE: Record<ImageTab, string> = {
  "Oral Cavity": "physical-exam/oral",
  Hair: "physical-exam/hair",
  Nails: "physical-exam/nails",
  Skin: "physical-exam/skin",
  "Atopic Dermatitis": "ad-minor/atopic",
};

const ATOPIC_LABELS = [
  "Erythema",
  "White Patches",
  "Darkening around the Eyelids",
  "Infra Orbital Folds",
  "Dry Lips",
  "Anterior Neck-Folds",
  "Dry Skin",
  "Increased Lines Over Palms",
  "Hand and Foot Eczema",
  "Nipple Eczema",
];

const DermImageViewerTab: React.FC<DermImageViewerTabProps> = ({
  emrId,
  activeSubTab,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeImageTab, setActiveImageTab] = useState<ImageTab>("Oral Cavity");

  const [dermImages, setDermImages] = useState<Record<string, string[]>>({});
  const [atopicImages, setAtopicImages] = useState<string[]>([]);
  const [signedImageMap, setSignedImageMap] = useState<Record<string, string[]>>({});
  const [selectedImage, setSelectedImage] = useState<string>("");

  /* =========================================
     AUTO CHANGE IMAGE TAB WHEN MAIN TAB CHANGES
  ========================================= */
  useEffect(() => {
    if (activeSubTab === "derma") {
      setActiveImageTab("Oral Cavity");
    } else {
      setActiveImageTab("Atopic Dermatitis");
    }
  }, [activeSubTab]);

  /* =========================================
     FETCH PHYSICAL EXAM IMAGES
  ========================================= */
  useEffect(() => {
    if (!emrId) return;

    const fetchDermImages = async () => {
      try {
        const res = await api.dataCollectionApi.get(
          `/api/forms/physical-exam/${emrId}`
        );

        if (res.data?.success && res.data?.data) {
          const data = res.data.data;

          // Safely extract Skin Images from BOTH the root and the new nested regions
          const skinImages: string[] = [];
          
          if (Array.isArray(data.skinExam?.imageUrls)) {
            skinImages.push(...data.skinExam.imageUrls);
          }
          
          const regions = ["face", "upperLimb", "lowerLimb", "trunk"];
          regions.forEach((region) => {
            if (Array.isArray(data.skinExam?.[region]?.imageUrls)) {
              skinImages.push(...data.skinExam[region].imageUrls);
            }
          });

          const normalizedImages: Record<string, string[]> = {
            Hair: data.hair?.imageUrls || [],
            Nails: data.nails?.imageUrls || [],
            "Oral Cavity": data.oralCavity?.imageUrls || [],
            Skin: skinImages,
          };

          setDermImages(normalizedImages);
        }
      } catch (err) {
        console.error("Failed to fetch dermatology images:", err);
      }
    };

    fetchDermImages();
  }, [emrId]);

  /* =========================================
     FETCH AD IMAGES
  ========================================= */
  useEffect(() => {
    if (activeImageTab !== "Atopic Dermatitis") return;

    const fetchAtopicImages = async () => {
      try {
        const res = await api.dataCollectionApi.get(
          `/api/forms/atopic-dermatitis/${emrId}`,
        );

        if (res.data?.success && Array.isArray(res.data?.data?.features)) {
          const allKeys: string[] = [];

          res.data.data.features.forEach((feature: any) => {
            if (Array.isArray(feature.imageUrls)) {
              feature.imageUrls.forEach((url: string) => {
                allKeys.push(url);
              });
            }
          });

          setAtopicImages(allKeys);
        }
      } catch (err) {
        console.error("Failed to fetch atopic images:", err);
      }
    };

    fetchAtopicImages();
  }, [activeImageTab, emrId]);

  /* =========================================
     FETCH SIGNED URLS - DERMA
  ========================================= */
  useEffect(() => {
    if (!Object.keys(dermImages).length) return;

    const fetchSignedUrls = async () => {
      const INTERNAL_TOKEN = "super-secret-password";
      const map: Record<string, string[]> = {};

      for (const [view, keys] of Object.entries(dermImages)) {
        map[view] = [];

        for (const fullPath of keys) {
          if (!fullPath) continue;

          try {
            let cleanPath = fullPath;

            if (fullPath.startsWith("http")) {
              const urlObj = new URL(fullPath);
              cleanPath = urlObj.pathname.substring(1); 
            }

            let module = "";
            let key = cleanPath;

            if (cleanPath.includes("/")) {
              const parts = cleanPath.split("/");
              module = `${parts[0]}/${parts[1]}`; 
              key = parts.slice(2).join("/");     
            } else {
              if (view === "Skin") {
                if (cleanPath.includes("_face_")) {
                  module = "physical-exam/skin/face";
                } else if (cleanPath.includes("_upper-limb_")) {
                  module = "physical-exam/skin/upper-limb";
                } else if (cleanPath.includes("_lower-limb_")) {
                  module = "physical-exam/skin/lower-limb";
                } else if (cleanPath.includes("_trunk_")) {
                  module = "physical-exam/skin/trunk";
                } else {
                  module = "physical-exam/skin";
                }
              } else {
                module = VIEW_TO_MODULE[view as ImageTab];
              }
            }

            const res = await api.S3config.get("/view-url", {
              params: { module, key },
              headers: { "x-internal-token": INTERNAL_TOKEN },
            });

            if (res.data?.url) {
              const signedUrl = res.data.url.startsWith("http") 
                ? res.data.url 
                : `https://${res.data.url}`;
              
              map[view].push(signedUrl);
            }
          } catch (err) {
            console.error(`Presign failed for ${view}:`, err);
          }
        }
      }

      setSignedImageMap(map);
    };

    fetchSignedUrls();
  }, [dermImages]);

  /* =========================================
     FETCH SIGNED URLS - AD
  ========================================= */
  useEffect(() => {
    if (!atopicImages.length) return;

    const fetchSignedUrls = async () => {
      const INTERNAL_TOKEN = "super-secret-password";
      const urls: string[] = [];

      for (const fullPath of atopicImages) {
        if (!fullPath) continue;

        if (fullPath.startsWith("http")) {
          urls.push(fullPath);
          continue;
        }

        try {
          const parts = fullPath.split("/");
          const module = `${parts[0]}/${parts[1]}`;
          const key = parts.slice(2).join("/");

          const res = await api.S3config.get("/view-url", {
            params: { module, key },
            headers: { "x-internal-token": INTERNAL_TOKEN },
          });

          if (res.data?.url) {
             const signedUrl = res.data.url.startsWith("http") 
                ? res.data.url 
                : `https://${res.data.url}`;
                
            urls.push(signedUrl);
          }
        } catch (err) {
          console.error("Presign failed for AD:", err);
        }
      }

      setSignedImageMap((prev) => ({
        ...prev,
        "Atopic Dermatitis": urls,
      }));
    };

    fetchSignedUrls();
  }, [atopicImages]);

  /* =========================================
     AUTO SELECT IMAGE
  ========================================= */
  useEffect(() => {
    const images = signedImageMap[activeImageTab] || [];
    setSelectedImage(images.length > 0 ? images[0] : "");
  }, [activeImageTab, signedImageMap]);


  /* =========================================
     HELPER: GET DYNAMIC THUMBNAIL TITLE
  ========================================= */
  const getThumbnailTitle = (url: string, tab: ImageTab, index: number) => {
    if (tab === "Atopic Dermatitis") {
      return ATOPIC_LABELS[index] || `File ${index + 1}`;
    }

    if (tab === "Skin") {
      if (url.includes("_face_") || url.includes("/face/")) return "Face";
      if (url.includes("_upper-limb_") || url.includes("/upper-limb/")) return "Upper Limbs";
      if (url.includes("_lower-limb_") || url.includes("/lower-limb/")) return "Lower Limbs";
      if (url.includes("_trunk_") || url.includes("/trunk/")) return "Trunk";
      return `Skin Image ${index + 1}`;
    }

    // Return null for Oral Cavity, Hair, and Nails so no title renders
    return null; 
  };


  return (
    <div className="derm-image-viewer-container">
      {/* SUB TABS */}
      <div className="sub-tabs-container">
        {(activeSubTab === "derma" ? DERMA_TABS : AD_TABS).map((tab) => (
          <button
            key={tab}
            className={`sub-tab ${activeImageTab === tab ? "active" : ""}`}
            onClick={() => setActiveImageTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* IMAGE AREA */}
      <div className="image-gallery-area">
        
        {/* THUMBNAILS */}
        <div className="thumbnails-bar">
          {(signedImageMap[activeImageTab] || []).map((url, index) => {
            const title = getThumbnailTitle(url, activeImageTab, index);

            return (
              <div
                key={index}
                className={`thumbnail ${selectedImage === url ? "active" : ""}`}
                onClick={() => setSelectedImage(url)}
              >
                {/* Only renders if title is not null (Skin & AD tabs) */}
                {title && (
                  <div className="thumbnail-title">
                    {title}
                  </div>
                )}
                
                <img src={url} alt={`thumb-${index}`} />
              </div>
            );
          })}
        </div>

        {/* MAIN IMAGE */}
        <div className="main-image-view">
          <ImageViewer
            imageSrc={
              selectedImage ||
              "https://placehold.co/800x600/f1f1f1/ccc?text=No+Images"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DermImageViewerTab;